export const LIMIT_POSTS_SECTION = 6